/**
 * Created by divyanshverma on 6/27/15.
 */
var app = angular.module('obto.data.reporting', []);

app.controller('RouteController', ['$scope', function($scope){

    var cnvs = document.getElementById('canvas');

    $scope.saveimage = function($event){
        var dataURL = cnvs.toDataURL('image/png');
        console.log(dataURL);
    };
}]);
